import angular from 'angular';

import * as invoiceActions from '../../../../store/actions/invoice';

import template from './add-receipt.html';

const mapStateToScope = (state) => {
  return {
    invoice: state.invoice,
    user: state.user.user,
  };
};

angular.module('myConsultApp').directive('addReceipt', () => {
  return {
    scope: {
      onContinue: '&',
    },
    controller: ($rootScope, $scope, $ngRedux, $http, Upload, ENV, Session, $location) => {
      $scope.init = () => {
        $scope.model = {};
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, invoiceActions)($scope);
        $scope.invoiceGetPurchaseLocations({ $http, ENV });
        $scope.isOrganizationUser = !$location.path().startsWith('/admin');
      };
      $scope.init();

      $scope.$on('$routeChangeStart', async () => {
        $scope.model = {};
      });

      $scope.invoiceListener = $scope.$watch('invoice', (invoiceStore) => {
        // keep local model in sync with redux store
        $scope.model.clinic = invoiceStore.clinic;
        if (
          invoiceStore.datePurchased &&
          $scope.model.datePurchased !== invoiceStore.datePurchased
        ) {
          $scope.model.datePurchased = invoiceStore.datePurchased;
        }
        if (invoiceStore.datePurchased === null) {
          $scope.model.datePurchased = '';
        }

        $scope.model.purchaseLocation = invoiceStore.purchaseLocation;
        $scope.model.file = invoiceStore.file;
        $scope.purchaseDetailsAreComplete =
          invoiceStore.clinic &&
          invoiceStore.purchaseLocation &&
          invoiceStore.datePurchased &&
          invoiceStore.receipts?.length > 0 &&
          invoiceStore.transaction_id;
      });

      $scope.getPurchaseLocationOptions = () =>
        Promise.resolve({
          locations: $scope.invoice.availablePurchaseLocations,
        });

      $scope.onChangeDate = (value) => {
        $scope.invoiceSetDate(value);
      };

      $scope.onChangePurchaseLocation = () => {
        $scope.invoiceSetPurchaseLocation($scope.model.purchaseLocation);
      };

      $scope.onAddReceipts = (files) => {
        if (files) {
          $scope.invoiceUploadReceipts({
            files,
            userId: $scope.invoice.user.id,
            Upload,
            ENV,
            accessToken: Session.accessToken,
          });
        }
      };

      $scope.onRemoveReceipt = (receipt) => $scope.invoiceRemoveReceipt({ receipt, $http, ENV });

      $scope.onChangeClinic = () => {
        $scope.invoiceSetClinic({ clinic: $scope.model.clinic, $http, ENV });
      };

      $scope.onSelectClinicFromPicker = (clinic) => {
        $scope.model.clinic = clinic;
        $scope.invoiceAddClinicToAvailableClinics(clinic);
        $scope.invoiceSetClinic({ clinic, $http, ENV });
        $scope.isShowingVetPicker = false;
      };

      $scope.onToggleVetPicker = () => {
        $scope.isShowingVetPicker = !$scope.isShowingVetPicker;
      };

      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
        $scope.invoiceListener();
      });
    },
    template,
  };
});
